export default {
  reference_number: "No. de Ref.",
  article_number: "No. de Art.",
  hrs: "hrs",
  mins: "mins",
  hr: "hr",
  min: "min",
  operators: ["contiene", "terminaCon", "igual", "noContiene", "noTerminaCon", "noIgual", "noEmpiezaCon", "empiezaCon"],
};
